import React from "react";
import classnames from "classnames";
import DatePicker, { registerLocale } from "react-datepicker";
import nl from "date-fns/locale/nl";
import moment from "moment";
import { FormattedMessage, injectIntl } from "react-intl";

import { Today } from "components/Icons";

import "./style.scss";

registerLocale("nl", nl);

interface IProps {
  startDate?: Date;
  label?: string;
  containerClassName?: string;
  kind?: string;
  className?: string;
  dateFormat?: string;
  intl: any;
  [key: string]: any;
}

const CNBDatePicker = ({
  intl: { locale, formatMessage },
  label,
  containerClassName = "",
  kind = "default",
  dateFormat = "dd-MM-yyyy",
  className,
  input: { value, onBlur, ...rest } = { value: undefined, onBlur: undefined },
  startDate = value,
  ...props
}: IProps) => {
  const selected = startDate && moment(startDate).toDate();

  return (
    <div className={containerClassName}>
      {label && <FormattedMessage id={label} tagName="label" />}
      <div id="cnb-datepicker">
        <DatePicker
          disabledKeyboardNavigation
          awareOfUnicodeTokens
          selected={selected}
          className={classnames("cnb-datepicker", kind, className)}
          dateFormat={dateFormat}
          locale={locale}
          timeCaption={formatMessage({ id: "TIME" })}
          {...rest}
          {...props}
        />
        <Today className="icon" />
      </div>
    </div>
  );
};

export default injectIntl(CNBDatePicker);
